/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const stepAtiva: Number = 1

const getters = {
  STEP_ATIVA: (state: any) => {
    return state.stepAtiva
  },
}

const actions = {}

const mutations = {
  STEP_ATIVA (context: any, stepAtiva) {
    context.stepAtiva = stepAtiva
  },
}

export default new Vuex.Store({
  state: {
    stepAtiva: stepAtiva,
  },
  getters: getters,
  actions: actions,
  mutations: mutations,
})
